import { render } from "./HelloWorld.vue?vue&type=template&id=2f4bc9fc&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/landing_page/landing_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__